export default "__VITE_ASSET__BWBrwaLu__"